import React from "react";
import { Grid, Box, Button } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import PropertyStatus from "./property-state";
import LinearProgressWithLabel from "../../linear-progress";

const colorMapper = {
  TRUE: "red",
  OK: "red",
  NOK: "green",
  FALSE: "green",
  NOT_KNOWN: "gray",
  NOT_CONFIGURED: "green",
};

const DeviceStates = ({ data, openModal, handleOpenModal }) => {
  const {
    ancState,
    audioMetrState,
    isAudioMetrCharged,
    isLockClosed,
    lockState,
    areHeadphonesPluggedIn,
    ancBattery,
    isAudioMetrBatteryBelowMinimum,
    audioMetrBattery,
    isAncCharged,
    frontendStatus,
    backendStatus,
  } = data;

  const dataToRender = [
    {
      text: "Backend",
      value: backendStatus,
      render: () => (
        <Box display="flex" alignItems="center">
          <Button size="small" variant="contained" onClick={handleOpenModal}>
            Logi systemu
          </Button>
        </Box>
      ),
    },
    { text: "Frontend (nginx)", value: frontendStatus },
    {
      text: "ANC",
      value: ancState,
      render: () => (
        <LinearProgressWithLabel
          helperText={"Bateria: "}
          text={ancBattery ? `${Math.round(ancBattery)}%` : "---"}
          value={ancBattery}
        />
      ),
    },
    { text: "ANC ładowanie", value: isAncCharged },
    {
      text: "AudioMetr",
      value: audioMetrState,
      render: () => (
        <Box display="flex" alignItems="center">
          {`Bateria: `}
          <FiberManualRecordIcon
            fontSize="large"
            style={{
              fill: colorMapper[isAudioMetrBatteryBelowMinimum || "NOT_KNOWN"],
            }}
          />
          {`${audioMetrBattery || "---"} mV`}
        </Box>
      ),
    },
    { text: "AudioMetr ładowanie", value: isAudioMetrCharged },
    { text: "Detektor klapki", value: lockState },
    { text: "Klapka zamknięta", value: isLockClosed },
    {
      text: "Podłączone słuchawki",
      value: areHeadphonesPluggedIn,
    },
  ];

  return (
    <Grid container direction="column">
      {dataToRender.map((d) => (
        <PropertyStatus key={d.text} {...d} />
      ))}
    </Grid>
  );
};
export default DeviceStates;
